import styled from 'styled-components';

export const Copyright = styled.a`
    fill: ${props => props.theme.colors.white};
    height: 25px;
    position: absolute;
    right: 30px;
    width: 25px;

    &:hover {
        fill: ${props => props.theme.colors.orange};
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
        right: 40px;
    }
`;

const FooterStyled = styled.footer`
    align-items: center;
    bottom: 0;
    display: flex;
    font-size: 16px;
    height: ${props => props.theme.footer.height};
    justify-content: center;
    position: relative;
    width: 100%;

    @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
        height: ${props => props.theme.footer.heightLarge};
    }

    .fade-enter & {
        opacity: 0.01;
        transform: translateY(20px);
    }

    .fade-enter-active & {
        opacity: 1;
        transform: translateY(0%);
        transition: all 300ms ease-out;
    }

    .fade-exit & {
        opacity: 1;
        transform: translateY(0%);
    }

    .fade-exit-active & {
        opacity: 0.01;
        transform: translateY(20px);
        transition: all 300ms ease-out;
    }
`;

export default FooterStyled;


// WEBPACK FOOTER //
// ./src/components/molecules/Footer/Footer.styled.js